// extracted by css-extract-rspack-plugin
export default {"root":"Loader-module__root___wHMwH"};